// extracted by mini-css-extract-plugin
module.exports = {"container":"ImportSuccess_container__2lvAu","img":"ImportSuccess_img__2s_H0","tip":"ImportSuccess_tip__2nSOX"};